<template>
  <div>
    <b-breadcrumb size="is-large" separator="has-succeeds-separator" aria-label="breadcrumbs">
      <b-breadcrumb-item tag="a" @click.prevent="goToList()">
        {{ $t('projects.title') }}
      </b-breadcrumb-item>
      <b-breadcrumb-item active>
        {{ title }}
      </b-breadcrumb-item>
    </b-breadcrumb>

    <div class="box">
      <b-field :label="$t('projects.name')">
        <b-input v-model="name" :placeholder="$t('projects.namePlaceholder')" />
      </b-field>

      <div class="buttons">
        <b-button type="is-primary" :loading="saving" @click="create()">{{ $t('projects.create') }}</b-button>
        <b-button @click="goToList()">{{ $t('global.cancel') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default defineComponent({
  name: 'ProjectAdd',
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const template = computed(() => String(route.params.template || 'empty'))
    const title = computed(() => route.query.title ? String(route.query.title) : template.value)
    const name = ref('')
    const saving = ref(false)

    const create = async () => {
      if (!name.value.trim()) return
      saving.value = true
      try {
        const id = await store.dispatch('createProject', { name: name.value.trim(), template: template.value })
        router.push({ name: 'project-edit', params: { id } })
      } finally {
        saving.value = false
      }
    }

    const goToList = () => router.push({ name: 'project-list' })

    return { template, title, name, saving, create, goToList }
  }
})
</script>

<style scoped>
</style>


